exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".leadership h4{font-size:1.3rem;font-weight:700;color:#414141}.leadership img{display:block;float:left;margin:0px 15px 15px 0px;border:1px solid rgba(0,0,0,0.5)}@media (max-width: 400px){.leadership img{float:none}}\n", ""]);

